/*
 * Texte du gabarit des pages d'authentification. Gardé ici plutôt que dans le
 * grand catalogue : ces phrases n'existent que sur ce panneau.
 */
export type AuthShellCopy = {
  brand: string;
  backHome: string;
  backHomeShort: string;
  live: string;
  liveValidated: string;
  liveShare: (percent: number) => string;
  liveFallbackTitle: string;
  liveFallbackText: string;
  headline: string;
  headlineSerif: string;
  description: string;
  statsLabel: string;
  statRecordings: string;
  statContributors: string;
  statLanguages: string;
  loadingFigures: string;
  themeToLight: string;
  themeToDark: string;
  showPassword: string;
  hidePassword: string;
  googlePending: string;
  callbackTitle: string;
  callbackPending: string;
  callbackHint: string;
  stepProgress: (step: number, total: number) => string;
  creatingAccount: string;
};

export const AUTH_SHELL_COPY: Record<'fr' | 'en', AuthShellCopy> = {
  fr: {
    brand: 'Yodi Data Hub',
    backHome: "Retour à l'accueil",
    backHomeShort: 'Accueil',
    live: 'En direct',
    liveValidated: 'Enregistrements validés',
    liveShare: (percent) => `${percent} % des enregistrements collectés`,
    liveFallbackTitle: 'Collecte ouverte',
    liveFallbackText: 'Enregistrez, transcrivez, validez.',
    headline: 'Votre langue mérite sa place',
    headlineSerif: "dans l'IA.",
    description:
      "Chaque phrase enregistrée, transcrite ou validée sur Yodi aide à construire des modèles qui comprennent les langues d'Afrique de l'Ouest.",
    statsLabel: 'La plateforme en chiffres',
    statRecordings: 'enregistrements collectés',
    statContributors: 'contributeurs',
    statLanguages: 'langues actives',
    loadingFigures: 'Chargement des chiffres de la plateforme',
    themeToLight: 'Passer en mode clair',
    themeToDark: 'Passer en mode sombre',
    showPassword: 'Afficher le mot de passe',
    hidePassword: 'Masquer le mot de passe',
    googlePending: 'Connexion avec Google…',
    callbackTitle: 'Connexion',
    callbackPending: 'Connexion en cours…',
    callbackHint: 'Nous vérifions votre session, vous allez être redirigé dans un instant.',
    stepProgress: (step, total) => `Étape ${step} sur ${total}`,
    creatingAccount: 'Création du compte…',
  },
  en: {
    brand: 'Yodi Data Hub',
    backHome: 'Back to home',
    backHomeShort: 'Home',
    live: 'Live',
    liveValidated: 'Validated recordings',
    liveShare: (percent) => `${percent}% of collected recordings`,
    liveFallbackTitle: 'Collection is open',
    liveFallbackText: 'Record, transcribe, validate.',
    headline: 'Your language deserves its place',
    headlineSerif: 'in AI.',
    description:
      'Every sentence recorded, transcribed or validated on Yodi helps build models that understand West African languages.',
    statsLabel: 'The platform in numbers',
    statRecordings: 'recordings collected',
    statContributors: 'contributors',
    statLanguages: 'active languages',
    loadingFigures: 'Loading platform figures',
    themeToLight: 'Switch to light mode',
    themeToDark: 'Switch to dark mode',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    googlePending: 'Signing in with Google…',
    callbackTitle: 'Sign in',
    callbackPending: 'Signing you in…',
    callbackHint: 'We are checking your session, you will be redirected in a moment.',
    stepProgress: (step, total) => `Step ${step} of ${total}`,
    creatingAccount: 'Creating your account…',
  },
};

export function authShellCopy(lang: string | undefined): AuthShellCopy {
  return lang === 'en' ? AUTH_SHELL_COPY.en : AUTH_SHELL_COPY.fr;
}
